import { render, staticRenderFns } from "./article_page.vue?vue&type=template&id=7bbea35e&scoped=true"
import script from "./article_page.vue?vue&type=script&lang=js"
export * from "./article_page.vue?vue&type=script&lang=js"
import style0 from "./article_page.vue?vue&type=style&index=0&id=7bbea35e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbea35e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bbea35e')) {
      api.createRecord('7bbea35e', component.options)
    } else {
      api.reload('7bbea35e', component.options)
    }
    module.hot.accept("./article_page.vue?vue&type=template&id=7bbea35e&scoped=true", function () {
      api.rerender('7bbea35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/website/navigation_article/article_page.vue"
export default component.exports